import gql from "graphql-tag";

export const SEND_RIGHT_MAIL = gql`
  mutation sendContactUsFormMail(
    $name: String!
    $email: String!
    $subject: String!
    $message: String!
  ) {
    addContactUsForm(
      input: {
        name: $name
        email: $email
        subject: $subject
        message: $message
      }
    ) {
      success
      message
    }
  }
`;
